import { CommonContainer } from 'components';

const AccessForbidden = (): JSX.Element => {
  return (
    <CommonContainer>
      Forbidden: You do not have permission to access this page
    </CommonContainer>
  );
};

export default AccessForbidden;
